import React from 'react'
import { Image } from '@/atoms/Image'
import { CaptionLG, CaptionXS } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { HeroBannerData } from '@/services/RecommendedBannerService/types'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { BaseHeroBanner } from '@/views/WatchLandingView/RecommendedBannerCarousel/RecommendedBanner/BaseHeroBanner'

type TicketsBannerProps = {
  banner: HeroBannerData
}

export const TicketsBanner: React.FC<TicketsBannerProps> = ({ banner }) => {
  const { t } = useTranslate('watch')
  const backdrop =
    banner.project.title?.landscapeBackdrop?.cloudinaryPath || banner.project.discoveryPosterLandscapeCloudinaryPath
  const mobileBackdrop =
    banner.project.title?.portraitBackdrop?.cloudinaryPath || banner.project.discoveryPosterCloudinaryPath

  return (
    <BaseHeroBanner
      recommendationId={banner.recommendationId}
      actionHref={`${paths.tickets.index}/${banner.project.slug}`}
      altText={banner.project.name as string}
      backdrop={backdrop}
      mobileBackdrop={mobileBackdrop}
      infoSection={
        <div className="mx-auto flex h-full w-full flex-col items-start justify-end gap-2 px-4 pb-8 md:ml-[60px] md:w-[300px] md:justify-center md:px-0 md:pb-0 lg:ml-[76px] lg:w-[410px] xl:ml-[104px] se:w-[300px] se:max-w-full">
          <Image
            alt={banner.project.name as string}
            className="mx-auto h-[80px] w-fit sm:h-[150px] md:mx-0 md:h-[120px] xl:h-[150px]"
            src={`${banner.project.title.logo?.cloudinaryPath}.webp`}
            height={150}
            width={270}
          />
          <CaptionXS weight="medium" className="sm:photon-caption-md md:text-bold w-full text-center md:text-left">
            {banner.flavorText}
          </CaptionXS>
          <div className="mx-auto bg-warm-01 px-12 py-2 md:mx-0 lg:mt-6">
            <CaptionLG weight="bold" className="uppercase">
              <Translate t={t} i18nKey="getShowtimes">
                Get Showtimes
              </Translate>
            </CaptionLG>
          </div>
        </div>
      }
    />
  )
}
